<script setup lang="ts">
/**
 * The pill names the theme it would switch you *to*, so it reads as an action rather than a
 * status — and is painted in that theme's own colours, so the swatch you are about to get is
 * the button you are about to press.
 *
 * `data-theme` on the button makes that literal: `tokens.css` keys both palettes off that
 * attribute rather than `:root`, so this one element resolves the opposite palette while the
 * page stays as it is. No second set of colours to keep in sync.
 */
import Icon from "@/components/Core/Icon.vue";
import { useTheme } from "@/composables/ui/useTheme";

const { isDark, toggle } = useTheme();
</script>

<template>
  <button
    type="button"
    :data-theme="isDark ? 'light' : 'dark'"
    class="fixed bottom-4 right-4 z-50 hidden h-[34px] items-center gap-2 rounded-full border border-line bg-surface-raised px-3 text-sm font-medium text-fg shadow-lg transition-colors hocus:bg-surface-muted md:flex"
    :aria-label="`Switch to ${isDark ? 'light' : 'dark'} theme`"
    :title="`Switch to ${isDark ? 'light' : 'dark'} theme`"
    @click="toggle"
  >
    <Icon
      :name="isDark ? 'sun' : 'moon'"
      class="size-3.5"
      aria-hidden="true"
    />
    {{ isDark ? "Light" : "Dark" }}
  </button>
</template>
